<template>
  <div>
    <div class="card card--section">
      <header class="card__header">
        <h1 class="card__title">
          Facebook Ads
        </h1>
      </header>
      <div class="card__body">
        <div class="form-group row v-centered">
          <label
            for="campaign_name"
            class="col-sm-2 label-control label-control--right mb-15"
            style="padding:0 15px 0 0"
          >
            Ads Image
          </label>
          <div class="col-sm-10 mb-15 v-centered">
            <input
              id="avatar"
              type="file"
              name="avatar"
              accept="image/png, image/jpeg"
              style="margin-right: 20px"

              @change="setImage($event)"
            >
            <img
              :src="ad.image"
              alt=""
              height="55"
            >
          </div>
          <label
            for="campaign_name"
            class="col-sm-2 label-control label-control--right mb-30"
          >
            Ads Message
          </label>
          <div class="form-group__control col-sm-10 mb-15">
            <textarea
              v-model="ad.message"
              class="form-control"
              placeholder="Enter ads message"
              rows="3"

              style="height: initial;"
            />
          </div>
        </div>
      </div>
    </div>
    <button
      class="button button--size-md button--primary right-button"
      @click="$emit('input', ad); $emit('created', null)"
    >
      CREATE FACEBOOK ADS >
    </button>
  </div>
</template>
<script>
export default {
  data() {
    return {
      ad: {
        image: null,
        message: null,
      },
    };
  },
  methods: {
    setImage(event) {
      const files = event.target.files || event.dataTransfer.files;
      if (!files.length) { return; }

      const reader = new FileReader();

      reader.readAsDataURL(files[0]);
      reader.onload = (e) => {
        this.ad.image = e.target.result;
      };
    },
  },
};
</script>
<style scoped>
.v-centered {
  display: flex;
  align-items: center;
}
</style>
